import type { CSSProperties } from 'react';

import { cx } from './classNames';

/**
 * Fabric-Ladeanzeige — Pendant zu `SfSpinner`. Das SVG ist unverändert aus
 * `Client/wwwroot/index.html` des Altclients übernommen.
 */
export interface SpinnerProps {
  /** Standard `true`; `false` blendet über `e-spin-hide` aus. */
  visible?: boolean;
  /** Kantenlänge in Pixeln, Standard 30. */
  size?: number;
  id?: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
}

export function Spinner(props: SpinnerProps) {
  const visible = props.visible ?? true;
  const size = props.size ?? 30;
  const center = size / 2;

  return (
    <div
      id={props.id}
      title={props.title}
      style={props.style}
      role="progressbar"
      className={cx('e-spinner-pane', visible ? 'e-spin-show' : 'e-spin-hide', props.className)}
    >
      <div className="e-spinner-inner">
        <svg
          className="e-spin-fabric"
          viewBox="0 0 30 30"
          style={{
            width: `${String(size)}px`,
            height: `${String(size)}px`,
            transformOrigin: `${String(center)}px ${String(center)}px ${String(center)}px`,
          }}
        >
          <path
            className="e-path-circle"
            d="M 15 15 m -15 0 a 15 15 0 1 0 30 0 a 15 15 0 1 0 -30 0"
          />
          <path
            className="e-path-arc"
            d="M 25.606601717798213 4.3933982822017885 A 15 15 0 0 0 4.393398282201785 4.3933982822017885"
          />
        </svg>
      </div>
    </div>
  );
}

export default Spinner;
